import { IAddressSearchCommon } from "../../../domain/entities/address/addressSearchInfo.types";
import { injectable } from "inversify";
import {
  HttpAddressSearchInfo,
  HttpAddressSearchResponse,
  IAddressSearchInfoCollectionParser,
} from "../addressRepository.types";
import {
  AddressSearchInfo,
  IAddressSearchInfo,
  IAddressSearchInfoCollection,
} from "@/domain/entities/address";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { Result, ok } from "neverthrow";

function parseAddressSearchInfo(
  data: HttpAddressSearchInfo
): IAddressSearchInfo {
  const addressSearchInfoData: IAddressSearchInfo = {
    zipNo: data.zipNo,
    dongAddress: data.jibunAddr,
    dongNo: data.admCd,
    roadAddress: data.roadAddr,
    roadNo: data.rnMgtSn,
    isUnder: data.udrtYn === "1",
    buildingMainNo: data.buldMnnm,
    buildingSubNo: data.buldSlno,
  };
  const addressSearchInfo = new AddressSearchInfo(addressSearchInfoData);
  return addressSearchInfo;
}

@injectable()
export class AddressSearchInfoCollectionParser
  implements IAddressSearchInfoCollectionParser
{
  toDomain(
    response: HttpAddressSearchResponse
  ): Result<IAddressSearchInfoCollection, ParseError> {
    try {
      const totalCount = Number(response.results.common.totalCount);
      const addressSearchInfos = response.results.juso?.map(
        parseAddressSearchInfo
      );
      const addresssSearchCommon: IAddressSearchCommon = {
        countPerPage: response.results.common.countPerPage ?? "",
        currentPage: response.results.common.currentPage ?? "",
        errorCode: response.results.common.errorCode,
        errorMessage: response.results.common.errorMessage,
        totalCount: response.results.common.totalCount,
      };
      const addressSearchInfoCollenction: IAddressSearchInfoCollection = {
        infos: addressSearchInfos,
        common: addresssSearchCommon,
        totalCount: totalCount ?? 0,
      };
      return ok(addressSearchInfoCollenction);
    } catch (error: any) {
      return error(new ParseError(error.message));
    }
  }
}
